(function () {
  'use strict';

  const drawer = document.querySelector('[data-v2-drawer]');
  const drawerToggle = document.querySelector('[data-v2-drawer-toggle]');
  const drawerClose = document.querySelectorAll('[data-v2-drawer-close]');

  if (drawerToggle) {
    drawerToggle.addEventListener('click', function () {
      drawer.classList.add('is-open');
      document.body.classList.add('v2-drawer-open');
    });
  }

  drawerClose.forEach(function (btn) {
    btn.addEventListener('click', function () {
      drawer.classList.remove('is-open');
      document.body.classList.remove('v2-drawer-open');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      drawer.classList.remove('is-open');
      document.body.classList.remove('v2-drawer-open');
    }
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function (e) {
    const details = document.querySelectorAll('.v2-header__details[open]');
    details.forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  // ============================================================
  // Mega menu: hover swap of featured image
  // ============================================================
  document.querySelectorAll('[data-v2-mega]').forEach(function (mega) {
    const feature = mega.querySelector('[data-v2-mega-feature]');
    if (!feature) return;
    const img = feature.querySelector('[data-v2-mega-feature-img]');
    const title = feature.querySelector('[data-v2-mega-feature-title]');
    const link = feature.querySelector('[data-v2-mega-feature-link]');
    const cta = feature.querySelector('[data-v2-mega-feature-cta]');
    if (!img) return;

    const initialSrc = img.getAttribute('src');
    const initialTitle = title ? title.textContent.trim() : '';
    const initialUrl = link ? link.getAttribute('href') : '';
    const ctaCollection = cta ? (cta.dataset.ctaCollection || 'VER COLECCIÓN') : '';
    const ctaProduct = cta ? (cta.dataset.ctaProduct || 'VER PRODUCTO') : '';

    function setCta(type) {
      if (!cta) return;
      const arrow = '<span aria-hidden="true">→</span>';
      const text = type === 'product' ? ctaProduct : ctaCollection;
      cta.innerHTML = text + ' ' + arrow;
    }

    const triggers = mega.querySelectorAll('[data-mega-image]');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('mouseenter', function () {
        const newSrc = trigger.dataset.megaImage;
        const newTitle = trigger.dataset.megaTitle;
        const newUrl = trigger.dataset.megaUrl;
        const newType = trigger.dataset.megaType;
        if (!newSrc || newSrc === img.getAttribute('src')) return;
        img.classList.add('is-swapping');
        setTimeout(function () {
          img.src = newSrc;
          if (title && newTitle) title.textContent = newTitle;
          if (link && newUrl) link.setAttribute('href', newUrl);
          setCta(newType);
          img.classList.remove('is-swapping');
        }, 200);
      });
    });

    mega.addEventListener('mouseleave', function () {
      if (img.getAttribute('src') !== initialSrc) {
        img.classList.add('is-swapping');
        setTimeout(function () {
          img.src = initialSrc;
          if (title) title.textContent = initialTitle;
          if (link) link.setAttribute('href', initialUrl);
          setCta('collection');
          img.classList.remove('is-swapping');
        }, 200);
      }
    });
  });

  // ============================================================
  // Open mega on hover (instead of click) on desktop
  // ============================================================
  if (window.matchMedia('(min-width: 990px)').matches) {
    document.querySelectorAll('.v2-header__details--mega, .v2-header__details').forEach(function (det) {
      let timer;
      det.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        det.setAttribute('open', '');
      });
      det.addEventListener('mouseleave', function () {
        timer = setTimeout(function () { det.removeAttribute('open'); }, 150);
      });
    });
  }
})();
